module.exports = __webpack_public_path__ + "static/media/ic_searchtype_fishingarea.c39ccece.svg";